var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchx2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Search_box",
    "data-name": "Search box",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_7_7",
    "data-name": "Component 7 \\u2013 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M30,27.358l-6.226-6.226a12.918,12.918,0,0,0,2.642-7.925A13.126,13.126,0,0,0,13.208,0,13.126,13.126,0,0,0,0,13.208,13.126,13.126,0,0,0,13.208,26.415a12.918,12.918,0,0,0,7.925-2.642L27.358,30ZM3.774,13.208a9.342,9.342,0,0,1,9.434-9.434,9.342,9.342,0,0,1,9.434,9.434,9.342,9.342,0,0,1-9.434,9.434A9.342,9.342,0,0,1,3.774,13.208Z",
    fill: "#324562"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchx2);
export default __webpack_public_path__ + "static/media/Search@x2.0338fae660928293e9daf7ccb0c6950f.svg";
export { ForwardRef as ReactComponent };